import React, { useEffect } from "react";
import Background from "common/Background";
import { Grid } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useNavigate, useLocation } from "react-router-dom";
import StepSix from "./stepSix";
import { connect } from "react-redux";
import StepFour from "./stepFour";
import StepFive from "./stepFive";

const steps = [1, 2];

function ReApplyStep({ stepcompleted }) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [confirmationResult, setconfirmationResult] = React.useState({});
  const navigate = useNavigate();

  let location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const query = new URLSearchParams(location.search);
    let step = query.get("step");
    if (stepcompleted != undefined && stepcompleted <= Number(step + 1)) {
      step = stepcompleted + 1;
      navigate(`/reApply?step=${step}`);
    }
    setActiveStep(step ? Number(step) - 1 : 0);
  }, []);

  const isStepOptional = (step) => {
    return step === 1;
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    navigate(`/reApply?step=${activeStep + 2}`);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    navigate(`/reApply?step=${activeStep}`);
  };
  return (
    <div className="bg_wrapper">
      <Background>
        <Grid
          container
          justifyContent={"center"}
          className="white-box2"
          alignItems={"center"}
          sx={{
            py: { xs: "30px ", sx: "20px", md: "30px" },
            px: { xs: "10px", sx: "10px", md: "10px" },
          }}
        >
          {activeStep != 0 && (
            <img
              src="img/back.svg"
              alt="Background"
              onClick={handleBack}
              className="back-btn"
            />
          )}

          <Grid
            lg={12}
            sx={{ mb: "40px" }}
            justifyContent={"center"}
            alignItems={"center"}
            container
          >
            <Grid lg={5} alignSelf={"center"}>
              <Stepper activeStep={activeStep} sx={{ mb: 2 }}>
                {steps.map((label, index) => {
                  const stepProps = {};

                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel> </StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Grid>

            {activeStep === 0 && (
              <StepFour reapply={true} handleNext={handleNext} />
            )}

            {activeStep === 1 && (
              <StepSix reapply={true} handleNext={() => {}} />
            )}
          </Grid>
        </Grid>
        <div id="recaptcha-container"></div>
      </Background>
    </div>
  );
}

const mapStateToProps = (state) => ({
  stepcompleted: state.auth.renewstepcompleted,
});

export default connect(mapStateToProps, null)(ReApplyStep);
